import React from "react";
import {
    Card,
    Typography,
    Stack,
    Chip,
    Box
} from "@mui/material";

import ModalHistorial from "./historial/ModalHistorial";
import ModalConfiguracion from "./ModalConfiguracion";
import ModalAlerta from "./ModalAlerta";

const CardVehiculos = ({
    vehiculo,
    onSelectVehiculo,
    seleccionado,
    compacto
}) => {

    const handleClick = () => {
        onSelectVehiculo(vehiculo);
    };

    const colorMap = {
        "En línea": "success",
        "Retraso": "warning",
        "Sin señal": "error"
    };

    const gpsColor = colorMap[vehiculo.gpsStatus] || "error";

    const nombreVehiculo = vehiculo.descripcion
        ? `${vehiculo.modelo} (${vehiculo.descripcion})`
        : vehiculo.modelo;

    return (
        <Card
            onClick={handleClick}
            sx={{
                mb: 1,
                cursor: "pointer",
                borderRadius: compacto ? "20px" : "20px",
                transition: "all .2s",

                border: seleccionado ? "2px solid #1976d2" : "1px solid transparent",
                backgroundColor: seleccionado ? "#e3f2fd" : "#fff",

                "&:hover": {
                    transform: "translateY(-2px)",
                    boxShadow: 4,
                }
            }}
        >
            {compacto ? (
                /* 🔥 COMPACTO */
                <Box sx={{ p: 0.5, textAlign: "center" }}>
                    <img
                        src={vehiculo.imagen}
                        alt=""
                        style={{
                            width: "100%",
                            height: "45px",
                            objectFit: "contain",
                        }}
                    />
                    <Typography fontSize={10} fontWeight={600}>
                        {vehiculo.modelo}
                    </Typography>
                </Box>
            ) : (
                /* 🔥 NORMAL */
                <Box sx={{ px: 1.5, py: 1.2 }}>
                    <Stack direction="row" spacing={1.5} alignItems="center">

                        <Box
                            sx={{
                                width: 95,
                                height: 65,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                flexShrink: 0
                            }}
                        >
                            <img
                                src={vehiculo.imagen}
                                alt={vehiculo.modelo}
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "contain"
                                }}
                            />
                        </Box>

                        <Box sx={{ flex: 1 }}>

                            <Stack direction="row" justifyContent="space-between">
                                <Box>
                                    <Typography fontWeight={600} fontSize={14}>
                                        {nombreVehiculo}
                                    </Typography>

                                    <Typography fontSize={13} fontWeight={500}>
                                        {vehiculo.patente}
                                    </Typography>
                                </Box>

                                <Chip
                                    label={vehiculo.gpsStatus}
                                    size="small"
                                    color={gpsColor}
                                    variant="outlined"
                                    sx={{ height: 18, fontSize: 10 }}
                                />
                            </Stack>

                            <Stack
                                direction="row"
                                spacing={2}
                                sx={{ fontSize: 11, opacity: 0.7, mt: 0.6 }}
                            >
                                <span>🚗 {vehiculo.vel || 0} km/h</span>
                                <span>🔋 {vehiculo.bateria || 0}%</span>
                            </Stack>

                            <Stack
                                direction="row"
                                spacing={1}
                                justifyContent="flex-end"
                                mt={0.5}
                                onClick={(e) => e.stopPropagation()}
                            >
                                <ModalHistorial vehiculoId={vehiculo.idVehiculo} />
                                <ModalConfiguracion vehiculoSeleccionado={vehiculo} />
                                <ModalAlerta vehiculoId={vehiculo.idVehiculo} />
                            </Stack>

                        </Box>
                    </Stack>
                </Box>
            )}
        </Card>
    );
};

export default CardVehiculos;